import { useSyncExternalStore } from 'react'

export type ToastKind = 'success' | 'error'
export interface Toast { id: string; kind: ToastKind; text: string }

type Listener = () => void

class ToastStore {
  private toasts: Toast[] = []
  private listeners = new Set<Listener>()

  getSnapshot = (): Toast[] => this.toasts

  subscribe = (l: Listener) => {
    this.listeners.add(l)
    return () => { this.listeners.delete(l) }
  }

  private emit() { this.listeners.forEach((l) => l()) }

  push(kind: ToastKind, text: string, ttlMs = 3200) {
    const id = Math.random().toString(36).slice(2)
    this.toasts = [...this.toasts, { id, kind, text }]
    this.emit()
    setTimeout(() => this.dismiss(id), ttlMs)
  }

  dismiss(id: string) {
    this.toasts = this.toasts.filter((t) => t.id !== id)
    this.emit()
  }
}

const store = new ToastStore()

export function useToasts() {
  const toasts = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot)
  return {
    toasts,
    push: (kind: ToastKind, text: string) => store.push(kind, text),
    dismiss: (id: string) => store.dismiss(id),
  }
}
